module.exports = __webpack_public_path__ + "static/img/battle_report2.97f64c23.png";